import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getvalidarray'
})
export class ValidArrayPipe implements PipeTransform {

  transform(obj=[]) {
       if(!obj?.[0]){
        return [{id:"no", value:"No data"}]
       }
       return obj
 
   }

}